import { StyleSheet, css } from 'aphrodite';
import { Button } from '../../../web/components-v2/Button';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

export function LoadError({ message, onRetry }: { message: string; onRetry: () => void }) {
	return (
		<div className={css(styles.root)} role='alert'>
			<span>{message}</span>
			<Button type='button' variant='outline' size='sm' onClick={onRetry}>
				Try again
			</Button>
		</div>
	);
}

const styles = StyleSheet.create({
	root: {
		alignItems: 'center',
		color: THEME.colors.text.main,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: THEME.typography.fontSizes.sm,
		gap: SPACE[12],
		justifyContent: 'center',
		padding: SPACE[16],
	},
});
